export const FIELD_PLACEHOLDERS = {
    precipitation_amount: "e.g., 0.0 mm/hr",
    wind: "e.g., 3.9 m/s",
    temperature_high: "e.g., 12°C",
    temperature_low: "e.g., 3°C",
    weather_conditions: "e.g., Clear / Light Rain",
};